<template>
  <b-container>
    <ProfileHero :user="user" v-if="user" />
    <FanProfileTabs :user="user" v-if="user" />
    <PlaylistList :items="playlists" v-if="playlists && playlists.length" />

    <b-row v-if="playlists && !playlists.length">
      <b-col class="text-center empty">
        This user hasn't created any playlists yet
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .empty {
    text-align: center;
    margin-top: 1em;
    color: $steel;
  }
</style>

<script>
import ProfileHero from '@/components/widgets/ProfileHero'
import FanProfileTabs from '@/components/widgets/FanProfileTabs'
import PlaylistList from '@/components/widgets/PlaylistList'

export default {
  name: 'Home',
  components: {
    FanProfileTabs,
    PlaylistList,
    ProfileHero
  },
  data () {
    return {
      user: null,
      playlists: null
    }
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      this.$store.dispatch('profile/getProfile', { id: this.$route.params.id }).then(user => {
        this.user = user
      })

      this.$store.dispatch('playlist/listPlaylists', { profile_id: this.$route.params.id }).then(async playlists => {
        this.playlists = await playlists.all()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/ProfilePlaylists.vue